import { JSX } from 'react';
import { HollywoodBetsFooter } from '../HollywoodBets';
import { SnaiFooter } from '../Snai';

export const Footer = (): JSX.Element => {
    if (_featuresConfig.licenseFooter === 'hwb') {
        return <HollywoodBetsFooter />;
    }

    if (_featuresConfig.licenseFooter === 'sni') {
        return <SnaiFooter />;
    }

    return null;
};
